import script from "./BannerTopVideoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTopVideoPage.vue?vue&type=script&setup=true&lang=js"

import "./BannerTopVideoPage.vue?vue&type=style&index=0&id=2a4618eb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a4618eb"]])

export default __exports__